// src/views/DepositarRetirarView.jsx
import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { useWeb3 } from '../contexts/Web3Context';
import { useWallet } from '../contexts/WalletContext';
import { useUser } from '../contexts/UserContext'; // IMPORTADO
import DepositModal from '../components/DepositModal';
import WithdrawModal from '../components/WithdrawModal';
import VerificationModal from '../components/VerificationModal'; // IMPORTADO
import AccountVerifiedModal from '../components/AccountVerifiedModal';
import { db, auth } from '../firebaseConfig';
import { doc, updateDoc, collection, query, orderBy, onSnapshot, where, limit } from 'firebase/firestore';

// ====================================================================
// │ COMPONENTES VISUALES │
// ====================================================================

const AccountStatusCard = ({ status, onActionClick }) => {
  const statusInfo = {
    verified: { text: 'Cuenta Verificada (Operaciones Habilitadas)', className: 'verified', buttonText: 'Cuenta Verificada', disabled: true },
    pending_validation: { text: 'Verificación Pendiente', className: 'pending', buttonText: 'Validar Monto', disabled: false },
    generating_deposit: { text: 'Generando Depósito', className: 'generating', buttonText: 'Esperando Depósito', disabled: true },
    unverified: { text: 'Cuenta Sin Verificar', className: 'connected', buttonText: 'Verificar Cuenta Bancaria', disabled: false },
  };

  const currentStatus = statusInfo[status] || statusInfo.unverified;

  return (
    <div className="card wallet-connection-card">
      <div className="wallet-info">
        <h4>Estado de la Cuenta</h4>
        <p>{currentStatus.text}</p>
      </div>
      <div className="wallet-action-status">
        <div className={`status-indicator ${currentStatus.className}`}></div>
        <button
          className={`status-button ${currentStatus.className}`}
          onClick={onActionClick}
          disabled={currentStatus.disabled}
          style={currentStatus.disabled ? { opacity: 0.7, cursor: 'default' } : {}}
        >
          {currentStatus.buttonText}
        </button>
      </div>
    </div>
  );
};

const DepositWithdrawCard = ({ inAppBalance, isDisabled, onDeposit, onWithdraw, status }) => (
  <div className="card estimated-balance-card">
    <div className="balance-details">
      <h4>Saldo en la Plataforma</h4>
      <p className="main-balance">{Math.floor(inAppBalance).toLocaleString('es-CL')} CLP</p>
      <p className="secondary-balance">Balance Interno</p>
    </div>
    <div className="balance-actionss">
      <button
        className="action-btn"
        disabled={isDisabled}
        onClick={onDeposit}
        title={isDisabled ? `Debes verificar tu cuenta. Estado: ${status}` : "Depositar CLP"}
      >
        Depositar
      </button>
      <button
        className="action-btn"
        disabled={isDisabled}
        onClick={onWithdraw}
        title={isDisabled ? `Debes verificar tu cuenta. Estado: ${status}` : "Retirar CLP"}
      >
        Retirar
      </button>
    </div>
    {isDisabled && (
      <div style={{ marginTop: '10px', fontSize: '0.8rem', color: '#ff9800', textAlign: 'center' }}>
        Aviso: Funciones restringidas hasta completar verificacion bancaria.
      </div>
    )}
  </div>
);

const TransactionHistory = ({ transactions }) => (
  <div className="card my-assets-card">
    <div className="assets-header">
      <h3>Historial de Ingresos y Retiros</h3>
      <a href="#">Ver todo →</a>
    </div>
    {transactions.length === 0 ? (
      <div className="no-records">
        <span className="no-records-icon">📄</span>
        <p>Aún no hay movimientos</p>
      </div>
    ) : (
      <table className="assets-table" style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ color: '#aaa', fontSize: '0.9rem', borderBottom: '1px solid #333' }}>
            <th style={{ padding: '10px' }}>Tipo</th>
            <th style={{ padding: '10px' }}>Detalle</th>
            <th style={{ padding: '10px' }}>Monto</th>
            <th style={{ padding: '10px' }}>Saldo</th> {/* NEW COLUMN */}
            <th style={{ padding: '10px' }}>Fecha</th>
            <th style={{ padding: '10px' }}>Estado</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map(tx => (
            <tr key={tx.id} style={{ borderBottom: '1px solid #222' }}>
              <td style={{ padding: '10px', color: tx.type === 'deposit' ? '#4caf50' : '#f44336' }}>
                {tx.type === 'deposit' ? 'Depósito' : 'Retiro'}
              </td>
              <td style={{ padding: '10px', fontSize: '0.85rem' }}>
                {tx.description || tx.method || '-'}
              </td>
              <td style={{ padding: '10px' }}>
                ${(tx.amount || 0).toLocaleString()} CLP
              </td>
              <td style={{ padding: '10px', fontWeight: 'bold', color: '#ffd700' }}>
                ${(tx.resultingBalance !== undefined ? tx.resultingBalance : 0).toLocaleString()}
              </td>
              <td style={{ padding: '10px', fontSize: '0.9rem', color: '#ccc' }}>
                {tx.timestamp?.toDate ? tx.timestamp.toDate().toLocaleString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Reciente'}
              </td>
              <td style={{ padding: '10px' }}>
                <span className="status-badge verified">Completado</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

// ====================================================================
// │ COMPONENTE PRINCIPAL (ACTUALIZADO)                   │
// ====================================================================
const DepositarRetirarView = () => {
  // --- LÓGICA Y ESTADO DINÁMICO ---
  const { wallet, provider, connectWallet } = useWeb3();
  const { balances, loadingBalances } = useWallet();
  const { userData } = useUser(); // USA EL CONTEXTO DE USUARIO REAL

  const [balance, setBalance] = useState('0.00 BNB');
  const [internalBalance, setInternalBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);

  // REFACTORED: Separate Effects for cleaner architecture
  const [manualHistory, setManualHistory] = useState([]);
  const [tradeHistory, setTradeHistory] = useState([]);

  useEffect(() => {
    const uid = userData?.uid || auth.currentUser?.uid;
    if (!uid) return;

    const API_URL = import.meta.env.VITE_API_URL || 'https://dashboard.xcoin.cl';

    // Fetch Manual History from VPS
    const fetchManualHistory = async () => {
      try {
        const res = await fetch(`${API_URL}/api/wallets/history?uid=${uid}&limit=500`);
        const json = await res.json();
        if (json.success && json.data) {
          setManualHistory(json.data.map(d => ({
            ...d,
            timestamp: { seconds: new Date(d.fecha).getTime() / 1000 },
            source: 'manual'
          })));
        }
      } catch (e) { console.error("Error fetching manual history:", e); }
    };

    // Fetch Trades from VPS
    const fetchTrades = async () => {
      try {
        const res = await fetch(`${API_URL}/api/transacciones?userId=${uid}&limit=500`);
        const json = await res.json();
        if (json.success && json.data) {
          const filteredDocs = json.data.filter(d => d.method !== 'Web3 (USDT)');
          setTradeHistory(filteredDocs.map(data => {
            let type = 'deposit';
            let description = `Venta ${data.cantidad} XCO`;

            if (data.tipo === 'compra') {
              type = 'withdrawal';
              description = `Compra ${data.cantidad} XCO`;
            } else if (data.tipo === 'compra_bnb') {
              type = 'withdrawal';
              description = `Compra ${parseFloat(data.cantidad).toFixed(4)} BNB`;
            }

            return {
              id: data.id || data.txHash,
              type,
              description,
              amount: data.montoCLP,
              timestamp: { seconds: new Date(data.fecha).getTime() / 1000 },
              status: 'completed',
              source: 'trade',
              origen: data.origen,
              tipo: data.tipo,
              method: data.method
            };
          }));
        }
      } catch (e) { console.error("Error fetching trades:", e); }
    };

    fetchManualHistory();
    fetchTrades();
  }, [userData]);

  // Combine & Calculate Running Balance (Forward Calculation)
  useEffect(() => {
    // 1. Combine
    const combined = [...manualHistory, ...tradeHistory];

    // 3. Calculate Running Balance Forward (0 -> Present)
    // Rationale: History is the strict source of truth. We start at 0 and replay all transactions.

    let runningBalance = 0;

    // Sort Oldest -> Newest for Forward Calc
    combined.sort((a, b) => {
      const tA = a.timestamp?.seconds || 0;
      const tB = b.timestamp?.seconds || 0;
      return tA - tB; // Oldest First
    });

    // Filter out Web3 USDT transactions (preserve existing logic) AND Staking AND Zero-amount transactions
    const filteredCombined = combined.filter(tx => {
      // 0. Blacklist (Staking IDs that refused to filter)
      const blacklist = ['JaYFuSIL1lVyZ8arlKTY', '2umj9kmtl2OtmFlcQYfW', 'l7ODLKvmnRDGouTtShT0', 'iW45eybsJuJx0YRtuVnh'];
      if (blacklist.includes(tx.id)) return false;

      if (tx.method === 'Web3 (USDT)') return false;

      // Staking Filter (Robust)
      if (tx.origen && tx.origen.toLowerCase() === 'staking') return false;

      const typeStr = (tx.tipo || '').toLowerCase();
      if (typeStr.includes('staking') || typeStr.includes('plazo fijo') || typeStr.includes('recompensa')) return false;

      // Filter out zero-amount transactions (e.g., USDT trades that don't affect CLP balance)
      const amount = parseInt(tx.amount) || 0;
      if (amount === 0) return false;

      return true;
    });

    const withBalance = filteredCombined.map(tx => {
      const amount = parseInt(tx.amount) || 0;

      if (tx.type === 'deposit') {
        runningBalance += amount;
      } else { // withdrawal
        runningBalance -= amount;
      }

      return { ...tx, resultingBalance: runningBalance };
    });

    // 4. Update State
    // "El de abajo manda": Update the Big Display Balance with the final calculated result
    setInternalBalance(runningBalance);

    // Reverse for Table Display (Newest First)
    setTransactions(withBalance.reverse());

  }, [manualHistory, tradeHistory]); // Removed internalBalance dependency to avoid loops

  // Estados Locales para Modales
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showDeposit, setShowDeposit] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);
  const [showVerifiedModal, setShowVerifiedModal] = useState(false);

  // Estado para validación del monto (Paso 2 - integrado rápido aquí también o reusar lógica)
  const [verifyingAmount, setVerifyingAmount] = useState(false);


  // Sincronizar Balance Interno
  // WARNING: Disabled directly syncing from database because we now calculate strict balance from history.
  // "El de abajo (history) manda".
  /*
  useEffect(() => {
    if (balances?.CLP) {
      setInternalBalance(balances.CLP);
    }
  }, [balances]);
  */

  // Efecto para obtener el saldo de la billetera externa
  useEffect(() => {
    if (wallet && provider) {
      const fetchBalance = async () => {
        try {
          const rawBalance = await provider.getBalance(wallet.accounts[0].address);
          const formattedBalance = ethers.formatEther(rawBalance);
          setBalance(`${parseFloat(formattedBalance).toFixed(4)} ${wallet.chains[0].token || 'BNB'}`);
        } catch (error) { console.error("Error fetching balance:", error); setBalance('Error'); }
      };
      fetchBalance();
    }
  }, [wallet, provider]);


  // Lógica de Validación de Monto (Replicada para esta vista si está en 'pending')
  const handleValidateAmount = async () => {
    const montoInput = prompt("Ingresa el monto exacto (CLP) que recibiste en tu cuenta:");
    if (!montoInput) return;

    const inputVal = parseInt(montoInput);
    const correctAmount = userData.verificationAmount;
    const currentAttempts = userData.verificationAttempts || 0;

    if (!correctAmount || correctAmount === 0) {
      alert("Error: Aún no hemos procesado tu depósito de verificación. Intenta más tarde.");
      return;
    }

    const userRef = doc(db, 'usuarios', auth.currentUser.uid);

    if (inputVal === correctAmount) {
      try {
        await updateDoc(userRef, { verificationStatus: 'verified', verificationAttempts: 0 });
        setShowVerifiedModal(true);
      } catch (e) {
        console.error(e);
        alert("Error al verificar.");
      }
    } else {
      // WRONG AMOUNT
      const newAttempts = currentAttempts + 1;
      if (newAttempts >= 2) {
        try {
          await updateDoc(userRef, {
            verificationStatus: 'unverified',
            verificationAmount: 0,
            verificationAttempts: 0
          });
          alert("❌ Has fallado los 2 intentos. Tu cuenta ha vuelto a estado 'No Verificado'.\n\nDebes solicitar la verificación nuevamente.");
        } catch (e) { console.error(e); }
      } else {
        try {
          await updateDoc(userRef, { verificationAttempts: newAttempts });
          alert(`❌ Monto incorrecto. Te queda ${2 - newAttempts} intento.`);
        } catch (e) { console.error(e); }
      }
    }
  };

  // Manejador de Acción Principal
  const handleWalletAction = () => {
    // REMOVED WALLET CHECK
    if (!userData) return;

    if (userData.verificationStatus === 'unverified' || !userData.verificationStatus) {
      setShowVerifyModal(true);
    } else if (userData.verificationStatus === 'pending_validation') {
      handleValidateAmount();
    }
  };

  const getStatusString = () => {
    // REMOVED WALLET CHECK
    if (!userData) return 'unverified';
    return userData.verificationStatus || 'unverified';
  };

  const currentStatus = getStatusString();
  const isActionDisabled = currentStatus !== 'verified';


  if (loadingBalances) {
    return (
      <div className="balance-view" style={{ padding: '20px', textAlign: 'center' }}>
        Cargando saldos...
      </div>
    );
  }

  return (
    <div className="balance-view">
      <AccountStatusCard
        status={currentStatus}
        onActionClick={handleWalletAction}
      />

      {/* Mensaje Informativo si está pendiente */}
      {currentStatus === 'pending_validation' && (
        <div style={{ margin: '10px 0', padding: '10px', background: 'rgba(255, 193, 7, 0.1)', border: '1px solid #ffc107', borderRadius: '5px', fontSize: '0.9rem' }}>
          <strong>Estado Pendiente:</strong> Hemos enviado el depósito de prueba. Revisa tu cuenta bancaria y haz clic en "Validar Monto".
        </div>
      )}
      {currentStatus === 'generating_deposit' && (
        <div style={{ margin: '10px 0', padding: '10px', background: 'rgba(244, 67, 54, 0.1)', border: '1px solid #f44336', borderRadius: '5px', fontSize: '0.9rem' }}>
          <strong>Generando Depósito:</strong> Hemos recibido tu solicitud. Nuestro equipo está procesando el depósito de verificación.
        </div>
      )}

      <DepositWithdrawCard
        inAppBalance={internalBalance}
        isDisabled={false} // BOTONES HABILITADOS VISUALMENTE
        status={currentStatus}
        onDeposit={() => {
          // "Depositar" siempre activo por solicitud del usuario (sin verificación previa requerida para abrir modal)
          setShowDeposit(true);
        }}
        onWithdraw={() => {
          if (currentStatus !== 'verified') {
            alert(`Debes verificar tu cuenta antes de retirar.\nEstado actual: ${currentStatus}`);
            return;
          }
          setShowWithdraw(true);
        }}
      />
      <TransactionHistory transactions={transactions} />

      <DepositModal isOpen={showDeposit} onClose={() => setShowDeposit(false)} />
      <WithdrawModal isOpen={showWithdraw} onClose={() => setShowWithdraw(false)} />
      <VerificationModal isOpen={showVerifyModal} onClose={() => setShowVerifyModal(false)} />
      <AccountVerifiedModal isOpen={showVerifiedModal} onClose={() => setShowVerifiedModal(false)} />
    </div>
  );
};

export default DepositarRetirarView;
